import React from "react";
import { Link } from "react-router-dom";
import clsx from "clsx";

import { ReactComponent as GroupIcon } from "../../assets/svg/discussion.svg";
import { ReactComponent as AnswersOtherIcon } from "../../assets/svg/answers_other_2.svg";
import { ReactComponent as SaveIcon } from "../../assets/svg/answerer_2.svg";
import { ReactComponent as EditIcon } from "../../assets/svg/edit_2.svg";
import { ReactComponent as QuestionnaireIcon } from "../../assets/svg/edit_questionnaire.svg";
import { groupPath } from "../../studentStore";
import { ILesson } from "../../state";

import styles from "./MaterialSidebar.module.scss";

export interface MaterialSidebarProps {
  hasIssue: boolean;
  isChangeAnswer: boolean;
  isEditMode: boolean;
  lesson: ILesson;
  currentPage: number;
  onSubmit: () => void;
  onResetAnswer: () => void;
  onSaveToStorage: () => void;
  onStartEditing: () => void;
  onShowModalAnswers: () => void;
  onShowModalEvaluate: () => void;
}

export const MaterialSidebar: React.FC<MaterialSidebarProps> = ({
  hasIssue,
  isChangeAnswer,
  isEditMode,
  lesson,
  currentPage,
  onSubmit,
  onResetAnswer,
  onSaveToStorage,
  onStartEditing,
  onShowModalAnswers,
  onShowModalEvaluate,
}) => {
  const showEvaluateButton = !!lesson.student_lesson_retrospective;

  return isEditMode ? (
    <div key="edit" className={styles.wrapper}>
      <button
        onClick={onSubmit}
        className={clsx(styles.actionBtn, styles.primary)}
        disabled={!hasIssue || !isChangeAnswer}
      >
        <SaveIcon className={styles.icon} />
        <span>
          ワーク
          <br />
          回答送信
        </span>
      </button>
      {showEvaluateButton && (
        <div
          className={clsx(styles.actionBtn, styles.hidden)}
          aria-hidden="true"
        />
      )}
      <button
        onClick={onResetAnswer}
        className={clsx(
          styles.actionBtn,
          styles.secondary,
          !isChangeAnswer && styles.hidden,
        )}
      >
        <span>
          下書きを
          <br />
          削除して終了
        </span>
      </button>
      <button
        onClick={onSaveToStorage}
        className={clsx(styles.actionBtn, styles.secondary)}
      >
        <span>
          {isChangeAnswer ? (
            <>
              下書きを
              <br />
              保存して終了
            </>
          ) : (
            <>編集を終了</>
          )}
        </span>
      </button>
    </div>
  ) : (
    <div key="normal" className={styles.wrapper}>
      <button
        onClick={onStartEditing}
        className={clsx(
          styles.actionBtn,
          isChangeAnswer ? styles.alert : styles.primary,
        )}
        disabled={!hasIssue}
      >
        <EditIcon className={styles.icon} />
        <span>
          {isChangeAnswer ? (
            <>
              下書きの
              <br />
              編集を再開
            </>
          ) : (
            <>
              ワーク
              <br />
              回答入力
            </>
          )}
        </span>
      </button>
      <button
        onClick={onShowModalAnswers}
        className={clsx(styles.actionBtn, styles.primary)}
        disabled={!hasIssue}
      >
        <AnswersOtherIcon className={styles.icon} />
        <span>みんなの回答</span>
      </button>
      <div className={clsx(styles.linkBtnWrapper)}>
        <Link
          to={{
            pathname: groupPath,
            state: {
              materialId: lesson.teaching_material_id,
              lessonId: lesson.id,
              page: currentPage,
            },
          }}
          className={clsx(styles.actionBtn, styles.primary)}
        >
          <GroupIcon className={styles.icon} />
          <span>グループ</span>
        </Link>
      </div>
      {showEvaluateButton && (
        <button
          onClick={onShowModalEvaluate}
          className={clsx(styles.actionBtn, styles.primary)}
        >
          <QuestionnaireIcon className={styles.icon} />
          <span>アンケート編集</span>
        </button>
      )}
    </div>
  );
};

export default MaterialSidebar;
